import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import { CONSENT_KEY, OPEN_SETTINGS_EVENT, readConsent, saveConsent } from "@/lib/consent";

const CookieBanner = () => {
  const [open, setOpen] = useState(false);
  const [details, setDetails] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const [marketing, setMarketing] = useState(false);

  useEffect(() => {
    if (!readConsent()) setOpen(true);
    const onOpen = () => {
      const c = readConsent();
      setAnalytics(!!c?.analytics);
      setMarketing(!!c?.marketing);
      setDetails(true);
      setOpen(true);
    };
    const onStorage = (e: StorageEvent) => {
      if (e.key === CONSENT_KEY) {
        const c = readConsent();
        if (c) {
          import("@/lib/consent").then(({ applyConsent }) => applyConsent(c, true));
          setOpen(false);
        }
      }
    };
    window.addEventListener(OPEN_SETTINGS_EVENT, onOpen);
    window.addEventListener("storage", onStorage);
    return () => {
      window.removeEventListener(OPEN_SETTINGS_EVENT, onOpen);
      window.removeEventListener("storage", onStorage);
    };
  }, []);

  if (!open) return null;

  const done = (a: boolean, m: boolean) => {
    saveConsent(a, m);
    setOpen(false);
    setDetails(false);
  };

  return (
    <div
      role="dialog"
      aria-label="Nastavení cookies"
      className="glass-card bg-card fixed z-[100] bottom-0 inset-x-0 sm:inset-x-auto sm:left-4 sm:bottom-4 sm:max-w-[26rem] w-full p-4 sm:p-5 text-foreground"
    >
      <h2 className="font-heading font-bold text-base mb-2 text-foreground">Cookies</h2>
      <p className="text-sm leading-relaxed text-muted-foreground">
        Na webu používáme cookies. Nezbytné zajišťují správné fungování stránek, analytické a marketingové nám (se
        svolením) pomáhají měřit návštěvnost a zobrazovat vám relevantní nabídky. Souhlas můžete kdykoli změnit.{" "}
        <Link to="/cookies" className="text-primary underline underline-offset-2 hover:opacity-80">
          Více informací
        </Link>
      </p>

      {details && (
        <div className="mt-4 space-y-3 border-t border-border/40 pt-4">
          {[
            { id: "nec", label: "Nezbytné", desc: "Nutné pro fungování webu. Vždy zapnuto.", val: true, set: undefined },
            { id: "ana", label: "Analytické", desc: "Měření návštěvnosti webu.", val: analytics, set: setAnalytics },
            { id: "mkt", label: "Marketingové", desc: "Google Ads a Meta Pixel – měření a relevantní reklama.", val: marketing, set: setMarketing },
          ].map((c) => (
            <div key={c.id} className="flex items-start justify-between gap-3">
              <label htmlFor={`ck-${c.id}`} className="text-sm text-foreground">
                <span className="font-semibold block">{c.label}</span>
                <span className="text-muted-foreground text-xs">{c.desc}</span>
              </label>
              <Switch id={`ck-${c.id}`} checked={c.val} disabled={!c.set} onCheckedChange={(v) => c.set?.(v)} />
            </div>
          ))}
        </div>
      )}

      <div className="mt-4 flex flex-col sm:flex-row gap-2">
        <Button className="w-full sm:w-auto" onClick={() => done(true, true)}>
          Přijmout vše
        </Button>
        <Button className="w-full sm:w-auto" onClick={() => done(false, false)}>
          Odmítnout vše
        </Button>
        {details ? (
          <Button variant="outline" className="w-full sm:w-auto" onClick={() => done(analytics, marketing)}>
            Uložit volbu
          </Button>
        ) : (
          <Button variant="outline" className="w-full sm:w-auto" onClick={() => setDetails(true)}>
            Nastavení
          </Button>
        )}
      </div>
    </div>
  );
};

export default CookieBanner;
